import React from 'react';
import PropTypes from 'prop-types';

import { OverlayTrigger, Icon } from 'components/common';

interface Props {
  message: string,
}

const NotificationHelp = ({ message }: Props) => (
  <OverlayTrigger placement="top"
                  overlay={message}
                  trigger={['hover', 'click']}
                  rootClose>
    <span>
      <Icon name="help" />
    </span>
  </OverlayTrigger>
);

NotificationHelp.propTypes = {
  message: PropTypes.string.isRequired,
};

export default NotificationHelp;
